var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loadFinish
    ? _c(
        "div",
        { staticClass: "chart-type" },
        _vm._l(
          _vm.renderMap[_vm.chart.render],
          function (renderItem, category) {
            return _c(
              "div",
              { key: category },
              [
                _c("el-divider", { staticClass: "chart-type-divider" }, [
                  _vm._v(_vm._s(_vm.$t(category))),
                ]),
                _vm._l(renderItem, function (container, i) {
                  return _c(
                    "div",
                    { key: i, staticStyle: { display: "block" } },
                    [
                      _c(
                        "div",
                        { staticClass: "radio-row" },
                        _vm._l(container, function (item, idx) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticStyle: {
                                position: "relative",
                                display: "block",
                              },
                              style: { top: item.isPlugin ? "5px" : "0" },
                            },
                            [
                              item.placeholder
                                ? _c(
                                    "el-radio",
                                    {
                                      staticClass: "disabled-none-cursor",
                                      attrs: {
                                        value: "",
                                        label: "",
                                        disabled: "",
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "chart-icon",
                                        attrs: { "icon-class": "" },
                                      }),
                                    ],
                                    1
                                  )
                                : item.isPlugin
                                ? _c("plugin-com", {
                                    attrs: {
                                      "component-name": item.value + "-type",
                                    },
                                  })
                                : _c(
                                    "el-radio",
                                    {
                                      staticClass: "radio-style",
                                      attrs: {
                                        value: item.value,
                                        label: item.value,
                                        border: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { title: _vm.$t(item.title) },
                                        },
                                        [
                                          _c("svg-icon", {
                                            staticClass: "chart-icon",
                                            attrs: { "icon-class": item.icon },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("p", { staticClass: "radio-label" }, [
                                        _vm._v(_vm._s(_vm.$t(item.title))),
                                      ]),
                                    ]
                                  ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          }
        ),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }